<!-- Add Toast for messages and ConfirmPopup for deletion -->
<p-toast></p-toast>
<!-- <p-confirmDialog></p-confirmDialog> --> <!-- Removed from here -->

<div class="domes-container"> <!-- Added container class -->
  <div class="header-section">
    <button pButton pRipple icon="pi pi-arrow-left" label="Back to Projects" class="p-button-text" (click)="navigateBackToProjects()" aria-label="Back to projects"></button>
    <h2>Your Experiences</h2> <!-- Added title -->
  </div>

  <!-- Loading/Error Indicators (Optional - Add if needed like in projects) -->
  <!-- <div *ngIf="isLoading" class="loading-indicator"> ... </div> -->
  <!-- <div *ngIf="error && !isLoading" class="error-message"> ... </div> -->

  <!-- Content Area -->
  <!-- Removed *ngIf="domes$ | async" -->
  <!-- Add a loading indicator -->
  <div *ngIf="isLoading" class="loading-indicator text-center p-4">
      <i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
      <p>Loading experiences...</p>
  </div>

  <!-- Show content only when not loading -->
  <div *ngIf="!isLoading">

    <!-- Filter Section (Search Only) -->
    <app-list-filter
      *ngIf="allDomes.length > 0"
      [searchTerm]="searchTerm"
      (searchTermChange)="searchTerm = $event; filterDomes()"
      [itemCount]="filteredDomes.length"
      itemLabel="experience"
      itemLabelPlural="experiences"
      placeholder="Search by name..."
      createButtonLabel="New Experience"
      (createClicked)="onNewExperienceClicked()">
    </app-list-filter>


    <!-- Views warning -->
    <div *ngIf="config.viewPercent > 79" style="margin-bottom: 8px;">
        <span style="color: red; font-weight: bold;">Warning: View usage at {{config.viewPercent}}%.</span>
        <span *ngIf="config.viewPercent > 94 && config.viewPercent < 110"> The end user experience will no
            longer work
            when you run out of views.</span>
        <span *ngIf="config.viewPercent > 109"> The end user experience is no longer available.</span>
        <a style="margin-left: 8px;" href="https://gallariepurchase.web.app" target="_blank">Buy More?</a>
    </div>

    <!-- Dome List (Single Column) -->
    <div *ngIf="filteredDomes.length > 0; else noDomes">
      <div class="domes-list-column"> <!-- Wrapper for single column -->
        <div class="experience-row" *ngFor="let dome of filteredDomes; index as i;"> <!-- Use filteredDomes -->
            <div class="card-item" style="width: 100%; border-radius: 8px;">
                <div class="orient" style="width: 100%; justify-content: space-between; gap: 16px;">
                    <div class="flex-row card-row-section" style="justify-content: space-between; flex-grow: 1;">
                        <span class="cardtitle" pTooltip="{{dome.name}}">{{dome.name}}</span>
                        <!-- <span class="toggle">
                            <button (click)="togglePublish(dome, $event)"
                                style="border: none; outline: none; background-color: transparent; padding-top: 4px;">
                                <img
                                    [src]="dome.published ? 'assets/images/toggle_on.svg' : 'assets/images/toggle_off.svg'" />
                            </button>
                            <span class="toggleDesc" style="height: 100%; margin-top: 5px;">{{dome.published ?
                                'Active' : 'Inactive'}}</span>
                        </span> -->
                        
                        <!-- Action menu button -->
                        <button pButton pRipple icon="pi pi-ellipsis-v" class="p-button-rounded p-button-text p-button-plain"
                            (click)="(role === 'admin' || role === 'editor' || role === 'super') ?
                                    generateMenuOptions(dome, $event) : generateViewerMenuOptions(dome, $event);
                                    menu.toggle($event)"
                            pTooltip="Actions"></button>
                    </div>
                </div>
            </div>
        </div> <!-- End experience-row -->
      </div> <!-- End domes-list-column -->
    </div> <!-- End *ngIf filteredDomes -->

    <!-- No Domes Template -->
    <ng-template #noDomes>
      <div class="no-domes-message animate-fade-in" style="display: flex; justify-content: center;">
        <div class="text-center" style="max-width: 500px; margin: 4rem auto; padding: 2rem; background-color: white; border-radius: 8px; box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1); text-align: center; display: flex; flex-direction: column; align-items: center;">
          <!-- Decorative icon with custom color -->
          <i class="pi pi-inbox" style="font-size: 4.5rem; color: #97D5B3; margin-bottom: 1.5rem; display: block;"></i>
          
          <!-- Increased font size -->
          <h3 style="font-size: 2.5rem; font-weight: 600; margin-bottom: 1rem; color: #343a40;">No experiences yet!</h3>
          
          <!-- Adjusted font size, no border -->
          <p style="font-size: 1.25rem; color: #6c757d; margin-bottom: 2rem;" *ngIf="!searchTerm">Ready to start sharing amazing experiences?</p>
          <p style="font-size: 1.25rem; color: #6c757d; margin-bottom: 2rem;" *ngIf="searchTerm">No experiences match your search term "{{searchTerm}}".</p>
          
          <!-- Keep the original button color -->
          <button pButton pRipple
                  label="Create Your First Experience"
                  icon="pi pi-plus"
                  class="p-button-lg create-first-experience-button"
                  (click)="onNewExperienceClicked()"
                  *ngIf="!searchTerm">
          </button>
        </div>
      </div>
    </ng-template>

  </div> <!-- End Content Area (!isLoading) -->
</div> <!-- End domes-container -->


<p-menu #menu [popup]="true" [model]="experienceOptions" [appendTo]="'body'" styleClass="actions-menu" [showTransitionOptions]="'0.12s cubic-bezier(0, 0, 0.2, 1)'" [hideTransitionOptions]="'0.1s linear'"></p-menu>
<p-confirmPopup></p-confirmPopup>
<br />
<div>
    View <a class="pointer" style="font-weight: bold;" (click)="openPdf()" herf="">Terms and Conditions</a> here.
</div>

<p-dialog
  [(visible)]="showQRDialog"
  [modal]="true"
  [style]="{width: '500px'}"
  [showHeader]="false"
  [draggable]="false"
  [resizable]="false"
  [contentStyle]="{'padding': '0'}"
  [baseZIndex]="1000">
  
  <div class="upload-modal-content">
    <div class="modal-header">
      <h3>Experience QR Code</h3>
      <button class="close-button" (click)="hideQR()">
        <i class="pi pi-times"></i>
      </button>
    </div>

    <div class="step-content">
      <p-tabView [(activeIndex)]="activeQRTab">
        <p-tabPanel header="Main URL">
          <div class="qr-content">
            <div class="qr-container">
              <qrcode
                [qrdata]="qrUrl"
                [width]="200"
                [errorCorrectionLevel]="'M'"
                [elementType]="elementType"
                [margin]="2"
                cssClass="qr-code">
              </qrcode>
            </div>

            <div class="url-section">
              <label>Share URL:</label>
              <div class="url-row">
                <span class="url-text" [title]="qrUrl">{{qrUrl}}</span>
                <div class="url-actions">
                  <button pButton
                    icon="pi pi-external-link"
                    class="p-button-text"
                    pTooltip="Open URL"
                    (click)="openUrl(qrUrl)">
                  </button>
                  <button pButton
                    icon="pi pi-copy"
                    class="p-button-text"
                    pTooltip="Copy URL"
                    (click)="copyUrl(qrUrl)">
                  </button>
                </div>
              </div>
            </div>
          </div>
        </p-tabPanel>
        <p-tabPanel header="Clip URL">
          <div class="qr-content">
            <div class="qr-container">
              <qrcode
                [qrdata]="qrUrlFallback"
                [width]="200"
                [errorCorrectionLevel]="'M'"
                [elementType]="elementType"
                [margin]="2"
                cssClass="qr-code">
              </qrcode>
            </div>

            <div class="url-section">
              <label>Share URL (Legacy):</label>
              <div class="url-row">
                <span class="url-text" [title]="qrUrlFallback">{{qrUrlFallback}}</span>
                <div class="url-actions">
                  <button pButton
                    icon="pi pi-external-link"
                    class="p-button-text"
                    pTooltip="Open URL"
                    (click)="openUrl(qrUrlFallback)">
                  </button>
                  <button pButton
                    icon="pi pi-copy"
                    class="p-button-text"
                    pTooltip="Copy URL"
                    (click)="copyUrl(qrUrlFallback)">
                  </button>
                </div>
              </div>
            </div>
          </div>
        </p-tabPanel>
      </p-tabView>
    </div>

    <div class="modal-footer">
      <p-splitButton
        label="Download PNG"
        icon="pi pi-download"
        (onClick)="downloadQR('png')"
        [model]="downloadOptions"
        styleClass="p-button-primary"
        appendTo="body">
      </p-splitButton>
    </div>
  </div>
</p-dialog>
